import React, { memo, useCallback, useState } from 'react';

import './style.sass';

import { CampaignStatus } from 'common/types/models/campaign';
import { Dropdown } from '../common/Dropdown';
import { StatusIndicator } from '../common/StatusIndicator';
import { SelectItem } from '../common/SelectItem';
import { CampaignStatusColor, CampaignStatusTitle } from 'app/utils/campaignStatusHelpers';
import { useBreakpointType } from 'app/services/breakpoints';

type Props = {
    currentStatus: CampaignStatus,
    onSelectStatus: (newStatus: CampaignStatus) => void,
    dropdownDirection?: 'right' | 'left',
};

const CAMPAIGN_STATUSES = CampaignStatus.Helper.Values;

export const CampaignStatusSelect = memo(({ currentStatus, onSelectStatus, dropdownDirection }: Props) => {
    const [isActiveDropdown, setIsActiveDropdown] = useState<boolean>(false);

    const { isMobile } = useBreakpointType();
    const activeIndex = CAMPAIGN_STATUSES.findIndex(item => item === currentStatus);

    const onClickSelectItem = useCallback((newStatus: CampaignStatus) => {
        if (onSelectStatus) {
            onSelectStatus(newStatus);
        }

        setIsActiveDropdown(false);

    }, [onSelectStatus]);

    return (
        <Dropdown
            isActive={isActiveDropdown}
            setIsActive={setIsActiveDropdown}
            button={
                <StatusIndicator
                    text={CampaignStatusTitle[currentStatus]}
                    indicatorColor={CampaignStatusColor[currentStatus]}
                />
            }
            directionX={dropdownDirection ? dropdownDirection : isMobile ? 'right' : 'left'}
            className="campaign-status-dropdown"
        >
            <div className="campaign-status-list">
                {CAMPAIGN_STATUSES.map((item, index) => (
                    <SelectItem
                        key={`${index}_select-item_${item}`}
                        isActive={index === activeIndex}
                        onClickItem={() => onClickSelectItem(item)}
                        text={CampaignStatusTitle[item]}
                    />
                ))}
            </div>
        </Dropdown>
    );
});
